/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RatingBandMeasurement } from './ratingBandMeasurement';


/**
 * 
 */
export interface EnergyUseSummary { 
    environmentalImpact: RatingBandMeasurement;
    energyRating: RatingBandMeasurement;
}

